// These are the libraries we have installed in this project
// npm install @mui/icons-material
// npm install @mui/material @emotion/react @emotion/styled

// aws --profile ventia-dev s3 sync build/ s3://ventia.app.freeform.io


// ventia dev
// export const AWS_API = 'https://oqmnoowu8f.execute-api.ap-southeast-2.amazonaws.com';
// export const region = 'ap-southeast-2';
// export const userPoolId = 'ap-southeast-2_8vHryXZTm';
// export const userPoolClientId = 'ikcg4bv42tff6vt13tl9bkcq6';

// ventia reg params
// export const AWS_API = 'https://6k2owm6tn0.execute-api.ap-southeast-2.amazonaws.com';
// export const region = 'ap-southeast-2';
// export const userPoolId = 'ap-southeast-2_OHMCgQqHr';
// export const userPoolClientId = '5tj2vn2ddr8nf7q8ut3kf9u13g';

// ventia prd params
export const AWS_API = 'https://f9oe3z0lfc.execute-api.ap-southeast-2.amazonaws.com';
export const region = 'ap-southeast-2';
export const userPoolId = 'ap-southeast-2_qJwegPE72';
export const userPoolClientId = '11nnab2no35qimp06dpolqg32m';
